import CsvModel from './globals/CsvModel';

export default class DemandLogisticsCsvModel extends CsvModel {
  static get path() {
    return '/backend/demand_logistics.csv';
  }
}
